import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { AUTH } from '../constants/testIds';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      // Redirect based on user role
      const destination = from || (result.user?.role === 'admin' ? '/admin' : '/account');
      navigate(destination, { replace: true });
    } else {
      setError(result.error);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen pt-24 flex items-center justify-center bg-surface">
      <div className="max-w-md w-full px-6">
        <div className="bg-card border border-border rounded-sm p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-serif font-bold text-primary mb-2">Welkom Terug</h1>
            <p className="text-muted-foreground">Log in op uw account</p>
          </div>

          {error && (
            <div
              className="bg-destructive/10 border border-destructive/30 text-destructive rounded-sm p-3 mb-6 text-sm"
              data-testid="login-error"
            >
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4" data-testid={AUTH.loginForm}>
            <div>
              <label className="text-sm font-medium text-primary mb-2 block">Email</label>
              <Input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="uw@email.com"
                data-testid={AUTH.emailInput}
              />
            </div>
            <div>
              <label className="text-sm font-medium text-primary mb-2 block">Wachtwoord</label>
              <Input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid={AUTH.passwordInput}
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 button-hover"
              data-testid={AUTH.submitBtn}
            >
              {loading ? 'Inloggen...' : 'Inloggen'}
            </Button>
          </form>

          <div className="mt-6 text-center space-y-2">
            <p className="text-sm text-muted-foreground">
              Nog geen account?{' '}
              <Link to="/register" className="text-primary font-medium hover:underline">
                Registreer hier
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
